import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'
import { reportAvatarFailure } from '@/shared/lib/avatarDiagnostics'

export const WebglDiagnostics = () => {
  const canvas = useThree((state) => state.gl.domElement)
  useEffect(() => {
    const handleLost = () => reportAvatarFailure('webgl_context_lost')
    canvas.addEventListener('webglcontextlost', handleLost)
    return () => canvas.removeEventListener('webglcontextlost', handleLost)
  }, [canvas])
  return null
}
